export class ApiConstants {
  static readonly AUTH_LOGIN = '/auth/login';
  static readonly AUTH_REFRESH = '/auth/refresh';
  static readonly AUTH_LOGOUT = '/auth/logout';
  static readonly COMPANIES = '/companies';
  static readonly USERS = '/users';
  static readonly ROLES = '/roles';
  static readonly APPROVAL = '/approval';
  static readonly NOTIFICATIONS = '/notifications';
  static readonly EMPLOYEE_TRANSACTION = '/EmployeeTransaction';
}
